import axios, { AxiosResponse } from 'axios';

import {
  IUpdateReferrerPayload,
  IUpdateReferrerUTMPayload,
} from './referrer.types';
import { auth0Client } from '../auth0Client';

const referrerApi = {
  fetchReferrer: async (): Promise<AxiosResponse> => {
    const config = {
      headers: {
        Authorization: `Bearer ${await auth0Client.getTokenSilently()}`,
      },
    };

    return axios.get(
      `${process.env.REACT_APP_REFERRAL_API}/referrers/me`,
      config,
    );
  },
  updateReferrer: async (
    payload: IUpdateReferrerPayload,
  ): Promise<AxiosResponse> => {
    const config = {
      headers: {
        Authorization: `Bearer ${await auth0Client.getTokenSilently()}`,
      },
    };

    return axios.put(
      `${process.env.REACT_APP_REFERRAL_API}/referrers/me`,
      payload,
      config,
    );
  },
  updateReferrerUTM: async (
    payload: IUpdateReferrerUTMPayload,
  ): Promise<AxiosResponse> => {
    const config = {
      headers: {
        Authorization: `Bearer ${await auth0Client.getTokenSilently()}`,
      },
    };

    return axios.put(
      `${process.env.REACT_APP_REFERRAL_API}/referrers/me`,
      payload,
      config,
    );
  },
};

export default referrerApi;
